import { css } from '@emotion/core'
import { measures, spacing, font } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const control = css`
  &:disabled {
    background-color: transparent;
    border-width: 0;
  }
`

export const formWrapper = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`

export const row = css`
  min-height: ${8 * unit}px;
  ${MQ.PHONES} {
    justify-content: space-between;
  }

  & label {
    width: 100%;
    display: block;
    margin-bottom: ${spacing(0.75)};
    font-weight: ${font.weight.medium};
    margin-left: ${spacing(2)};
  }
`
